import axios from 'axios';
import { getCookie } from './cookies';
import { toast } from 'react-toastify';
import i18n from '../i18n';
import { updateAuthPermissions } from '../Redux/Reducers/AuthReducer';
import store from '../store.js';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || process.env.REACT_APP_BASEURL || 'http://192.168.1.23:5000',
});

axiosInstance.interceptors.request.use(
    (config) => {
        // Add Accept-Language header based on current app language
        config.headers['Accept-Language'] = i18n.language?.split('-')[0] || 'en';

        // let token = getCookie('token');

        let token = sessionStorage.getItem('admin-token');

        if (typeof window !== 'undefined') {
            const localToken = sessionStorage.getItem('accessToken');
            if (localToken) {
                token = localToken;
            }
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json';
        }

        if ((config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'multipart/form-data';
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const message = error.response?.data?.message || error.message || 'Something went wrong';

        const permissions = error.response.data?.permissions || {};

        if (permissions && Object.keys(permissions).length > 0) {
            store.dispatch(updateAuthPermissions(permissions));
        }
        if (error.response?.status === 401) {
            const isLoginAPI = error.config.url.includes('/api/admin/auth/login');

            if (!isLoginAPI) {
                sessionStorage.removeItem('admin-token');
                sessionStorage.removeItem('admin-user');

                if (typeof window !== 'undefined') {
                    window.location.href = '/sign-in';
                }
            }
        } else {
            toast.error(message);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
